var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelationships(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4039 25.0676H19.0919C20.9719 25.0676 22.4958 23.5436 22.4958 21.6637V19.4732C22.4958 18.7758 22.2862 18.0914 21.806 17.5856C20.7312 16.4535 18.441 14.546 15.2229 14.5626C12.0103 14.5792 9.74712 16.4667 8.68469 17.5886C8.20754 18.0924 8 18.7736 8 19.4676V21.6637C8 23.5436 9.52397 25.0676 11.4039 25.0676Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0292 9.78072C21.0292 12.9733 18.4411 15.5614 15.2485 15.5614C12.0559 15.5614 9.46777 12.9733 9.46777 9.78072C9.46777 6.58812 12.0559 4 15.2485 4C18.4411 4 21.0292 6.58812 21.0292 9.78072ZM13.9279 9.01715C13.9279 9.84366 13.2579 10.5137 12.4314 10.5137C11.6048 10.5137 10.9348 9.84366 10.9348 9.01715C10.9348 8.19064 11.6048 7.52062 12.4314 7.52062C13.2579 7.52062 13.9279 8.19064 13.9279 9.01715ZM17.8892 10.5137C18.7157 10.5137 19.3858 9.84366 19.3858 9.01715C19.3858 8.19064 18.7157 7.52062 17.8892 7.52062C17.0627 7.52062 16.3927 8.19064 16.3927 9.01715C16.3927 9.84366 17.0627 10.5137 17.8892 10.5137Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationships);
export default __webpack_public_path__ + "static/media/relationships.660e5bfe2f6fd0115b2f99a2ff0f907a.svg";
export { ForwardRef as ReactComponent };